import type { TranslationMessages } from '../../types';

export const checklist: TranslationMessages = {
  title: 'Daily Checklist',
  subtitle: 'Your daily task checklist with completion tracking',
  loading: 'Loading checklist...',
  today_tasks: "Today's Tasks",
  completed_tasks: 'Completed Tasks',
  pending_tasks: 'Pending Tasks',
  task_completion: 'Task Completion',
  upload_evidence: 'Upload Evidence',
  add_notes: 'Add Notes',
  mark_complete: 'Mark Complete',
  task_completed: 'Task Completed',
  completion_time: 'Completion Time',
  evidence_uploaded: 'Evidence Uploaded',
  manager_review: 'Manager Review',
  no_tasks: 'No tasks assigned for today',
  stats_completed: 'Completed',
  stats_progress: 'Progress',
  stats_time_spent: 'Time Spent',
  stats_date: 'Date',
  add_custom_task: 'Add Custom Task',
  add_item: 'Add Item',
  cancel: 'Cancel',
  task_title: 'Task Title',
  task_title_placeholder: 'Enter task title',
  description: 'Description (Optional)',
  description_placeholder: 'Enter task description',
  category: 'Category',
  category_custom: 'Custom',
  category_opening: 'Opening',
  category_closing: 'Closing',
  category_maintenance: 'Maintenance',
  category_customer_service: 'Customer Service',
  priority: 'Priority',
  priority_low: 'Low',
  priority_medium: 'Medium',
  priority_high: 'High',
  estimated_duration: 'Estimated Duration (minutes)',
  add_task_button: 'Add Task',
  tasks: 'Tasks',
  category_opening_desc: 'Tasks to complete when opening the store',
  category_closing_desc: 'Tasks to complete when closing the store',
  category_maintenance_desc: 'Regular maintenance and cleaning tasks',
  category_customer_service_desc: 'Customer service and interaction tasks',
  category_custom_desc: 'Your custom tasks and notes',
  completed_label: '✅ Completed',
  completed_at: 'at',
  failed_load: 'Failed to load checklist data',
  add_title_required: 'Please enter a title for the checklist item',
  item_added: 'Custom checklist item added',
  item_updated: 'Checklist item updated successfully!',
  item_deleted: 'Checklist item deleted successfully!',
  all_completed_title: '🎉 All Tasks Completed!',
  all_completed_message:
    "Great job! You've completed all %{count} tasks in %{time} minutes.",
  edit_title: 'Edit Checklist Item',
  edit_description: 'Make changes to the checklist item below.',
  edit_duration_label: 'Duration (min)',
  save_changes: 'Save Changes',
  delete_title: 'Are you sure?',
  delete_description:
    'This action cannot be undone. This will permanently delete the checklist item.',
  delete_button: 'Delete',
};
